import React, { Fragment } from 'react';
import Slider from 'react-slick';

import { LINEUP } from './constants';
import './BodyToystory.scss';

export const BodyToystory = ({ baseImgUrl }) => {
  const pointSetting = {
    infinite: true,
    dots: false,
    speed: 500,
    centerMode: true,
    variableWidth: true,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 9999,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          variableWidth: false,
          dots: true,
        },
      },
    ],
  };

  const productSetting = {
    infinite: true,
    dots: true,
    speed: 500,
    variableWidth: true,
    centerMode: true,
    arrows: true,
    adaptiveHeight: true,
  };

  const renderHeader = ({ title, key, number, price }) => {
    const overrides = {
      'woody-1': 'woody-figure-1',
      'woody-2': 'woody-figure-2',
      'buzz-1': 'buzz-figure-1',
      'buzz-2': 'buzz-figure-2',
      'bo-peep': 'bopeep-figure',
      'mr-and-mrs-potato-head': 'mr-and-mrs-potato-figure',
    };

    const fileName = overrides[key] || `${key}-figure`;

    const titles = {
      'Buzz Lightyear': (
        <>
          Buzz
          <br />
          Lightyear
        </>
      ),
      'Mr. & Mrs. Potato Head': (
        <>
          Mr. & Mrs.
          <br />
          Potato Head
        </>
      ),
    };
    const mainTitle = titles[title] || title;

    return (
      <div className="body-toystory__lineup__header" data-key={key}>
        <img
          alt={title}
          className="body-toystory__lineup__header__img"
          data-aos="fade-left"
          data-aos-duration="1000"
          data-key={key}
          src={`${baseImgUrl}/lineup/${fileName}.webp`}
        />
        <h3
          data-aos
          className="body-toystory__lineup__header__title"
          data-aos-duration="1000"
          data-key={key}
        >
          {mainTitle}
        </h3>
        <div className="body-toystory__lineup__header__text-sp">
          <p className="body-toystory__lineup__header__product-numbers">{number}</p>
          <p className="body-toystory__lineup__header__price">{price}</p>
        </div>
      </div>
    );
  };

  const renderPreview = (key, number) => {
    const isShow2Way = key === 'woody-1' || key === 'buzz-1';

    const overrides = {
      'bo-peep': 'bopeep',
      'mr-and-mrs-potato-head': 'mr-and-mrs-potato',
    };

    const imgKey = overrides[key] || key;

    return (
      <div className="body-toystory__lineup__body__preview" data-key={key}>
        <picture>
          <source
            media="(min-width:768px)"
            srcSet={`${baseImgUrl}/lineup/preview/preview-${imgKey}_pc.webp`}
            type="image/webp"
          />
          <img
            alt={number}
            className="body-toystory__lineup__body__preview-img"
            data-key={key}
            src={`${baseImgUrl}/lineup/preview/preview-${imgKey}_sp.webp`}
          />
        </picture>

        {isShow2Way && (
          <div
            className="body-toystory__lineup__body__preview-logo"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-key={key}
          >
            <p>
              2WAY <br />
              GLASSES
            </p>
            <p>
              Polarised <br />
              Lenses
            </p>
          </div>
        )}
      </div>
    );
  };

  const renderBody = ({ key, number, price, desc, points }) => {
    return (
      <div className="body-toystory__lineup__body">
        <div className="body-toystory__lineup__body__layout" data-key={key}>
          {renderPreview(key, number)}

          <div className="body-toystory__lineup__body__content" data-key={key}>
            <div className="body-toystory__lineup__header__text-pc">
              <p className="body-toystory__lineup__header__product-numbers">{number}</p>
              <p className="body-toystory__lineup__header__price">{price}</p>
            </div>

            <p className="body-toystory__lineup__body__desc" data-key={key}>
              {desc}
            </p>

            <Slider {...pointSetting} className="body-toystory__lineup__body__points">
              {points.map((text, index) => (
                <li key={`point-${key}-${index + 1}`}>
                  <div className="body-toystory__lineup__body__point-sp">
                    <img
                      alt={text}
                      className="body-toystory__lineup__body__point-img"
                      src={`${baseImgUrl}/lineup/products/${number}/point-${index + 1}.webp`}
                    />
                    <p className="body-toystory__lineup__body__point-tag">
                      <span>POINT {index + 1}</span>
                    </p>
                    <p className="body-toystory__lineup__body__point-desc">{text}</p>
                  </div>

                  <div className="body-toystory__lineup__body__point-pc">
                    <img
                      alt={text}
                      className="body-toystory__lineup__body__point-img"
                      src={`${baseImgUrl}/lineup/products/${number}/point-${index + 1}.webp`}
                    />
                    <div>
                      <p className="body-toystory__lineup__body__point-tag">
                        <span>POINT {index + 1}</span>
                      </p>
                      <p className="body-toystory__lineup__body__point-desc">{text}</p>
                    </div>
                  </div>
                </li>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    );
  };

  const renderFooter = ({ limit, number }) => {
    return (
      <div className="body-toystory__lineup__footer">
        <div data-aos="fade-up" data-aos-duration="1000">
          <Slider {...productSetting} className="body-toystory__lineup__footer__glasses">
            {Array.from({ length: limit }, (_, index) => (
              <li key={`${number}-${index + 1}`}>
                <div className="body-toystory__lineup__footer__glasses__item">
                  <img
                    alt={number}
                    src={`${baseImgUrl}/lineup/products/${number}/${number}_0${index + 1}.webp`}
                  />
                </div>
              </li>
            ))}
          </Slider>
        </div>

        <div className="body-toystory__lineup__footer__button">
          <a
            className="base-toystory__btn--primary"
            href={`/sg/en/toystory-${number.toLowerCase()}-c1-eyeglasses.html`}
          >
            <span>ONLINE STORE</span>
          </a>
        </div>
      </div>
    );
  };

  return (
    <Fragment>
      <section className="body-toystory__lineup">
        <div className="body-toystory__lineup__zone" data-key="woody" id="woody-1">
          {renderHeader(LINEUP.woody.products[0])}
          {renderBody(LINEUP.woody.products[0])}
          {renderFooter(LINEUP.woody.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="woody" id="woody-2">
          {renderHeader(LINEUP.woody.products[1])}
          {renderBody(LINEUP.woody.products[1])}
          {renderFooter(LINEUP.woody.products[1])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="buzz" id="buzz-1">
          {renderHeader(LINEUP.buzz.products[0])}
          {renderBody(LINEUP.buzz.products[0])}
          {renderFooter(LINEUP.buzz.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="buzz" id="buzz-2">
          {renderHeader(LINEUP.buzz.products[1])}
          {renderBody(LINEUP.buzz.products[1])}
          {renderFooter(LINEUP.buzz.products[1])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="jessie" id="jessie">
          {renderHeader(LINEUP.jessie.products[0])}
          {renderBody(LINEUP.jessie.products[0])}
          {renderFooter(LINEUP.jessie.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="rex" id="rex">
          {renderHeader(LINEUP.rex.products[0])}
          {renderBody(LINEUP.rex.products[0])}
          {renderFooter(LINEUP.rex.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="lotso" id="lotso">
          {renderHeader(LINEUP.lotso.products[0])}
          {renderBody(LINEUP.lotso.products[0])}
          {renderFooter(LINEUP.lotso.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="aliens" id="aliens">
          {renderHeader(LINEUP.aliens.products[0])}
          {renderBody(LINEUP.aliens.products[0])}
          {renderFooter(LINEUP.aliens.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="bo-peep" id="bo-peep">
          {renderHeader(LINEUP.boPeep.products[0])}
          {renderBody(LINEUP.boPeep.products[0])}
          {renderFooter(LINEUP.boPeep.products[0])}
        </div>

        <div
          className="body-toystory__lineup__zone"
          data-key="mr-and-mrs-potato-head"
          id="mr-and-mrs-potato-head"
        >
          {renderHeader(LINEUP.mrAndMrsPotatoHead.products[0])}
          {renderBody(LINEUP.mrAndMrsPotatoHead.products[0])}
          {renderFooter(LINEUP.mrAndMrsPotatoHead.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="slinky-dog" id="slinky-dog">
          {renderHeader(LINEUP.slinkyDog.products[0])}
          {renderBody(LINEUP.slinkyDog.products[0])}
          {renderFooter(LINEUP.slinkyDog.products[0])}
        </div>

        <div className="body-toystory__lineup__zone" data-key="sid-phillips" id="sid-phillips">
          {renderHeader(LINEUP.sidPhillips.products[0])}
          {renderBody(LINEUP.sidPhillips.products[0])}
          {renderFooter(LINEUP.sidPhillips.products[0])}
        </div>
      </section>
    </Fragment>
  );
};
